$(document).ready(function () {
  var $header = $('.header')

  // --container-gutter-2 = (screen width − .container width) / 2, measured from
  // the real element and kept in sync on resize (CSS holds a fallback value)
  function initContainerGutter() {
    var root = document.documentElement
    // the plain .container (only that class, no modifiers)
    var container = null
    var all = document.querySelectorAll('.container')
    for (var i = 0; i < all.length; i++) {
      if (all[i].classList.length === 1) {
        container = all[i]
        break
      }
    }
    container = container || all[0]
    if (!container) return

    function update() {
      // clientWidth excludes the scrollbar, i.e. the width .container centres in.
      // Negative offset that pulls a bleed element out to the viewport edge:
      // it clears both the centring gap ((screen − .container) / 2) AND the
      // container's own 1.5rem side padding → value = -(gutter + 1.5rem)
      var gutter = (root.clientWidth - container.offsetWidth) / 2
      root.style.setProperty(
        '--container-gutter-2',
        'calc((' + gutter + 'px + 1.5rem) * -1)',
      )
    }

    update()
    var resizeT
    window.addEventListener('resize', function () {
      clearTimeout(resizeT)
      resizeT = setTimeout(update, 150)
    })
  }

  initContainerGutter()

  function toggleHeaderBlur() {
    var sc = $(window).scrollTop()
    if (sc > 10) {
      $header.addClass('is-blurred')
    } else {
      $header.removeClass('is-blurred')
    }
  }

  function setHeaderColor(color) {
    $header.removeClass('is-black is-white')
    if (color === 'black' || color === 'white') {
      $header.addClass('is-' + color)
    }
  }

  if (
    window.gsap &&
    (window.ScrollTrigger ||
      (gsap && gsap.plugins && gsap.plugins.ScrollTrigger))
  ) {
    try {
      if (gsap && gsap.registerPlugin && window.ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger)
      }
    } catch (e) {}

    var targets = gsap.utils.toArray('[data-header-color]')
    targets.forEach(function (el) {
      var color = el.getAttribute('data-header-color')
      ScrollTrigger.create({
        trigger: el,
        start: 'top top',
        end: 'bottom top',
        onEnter: function () {
          setHeaderColor(color)
        },
        onEnterBack: function () {
          setHeaderColor(color)
        },
      })
    })

    // initial check handled by ScrollTrigger when it initializes
  } else {
    var $blocks = $('[data-header-color]')
    function checkBlocksOnScroll() {
      var found = false
      $blocks.each(function () {
        var rect = this.getBoundingClientRect()
        if (rect.top <= 1 && rect.bottom > 0) {
          setHeaderColor(this.getAttribute('data-header-color'))
          found = true
          return false
        }
      })
      if (!found) {
        $header.removeClass('is-black is-white')
      }
    }

    $(window).on('scroll', checkBlocksOnScroll)
    // initial check
    checkBlocksOnScroll()
  }

  function initIntroLogosMarquee() {
    var marquee = document.querySelector('.intro__logos')
    if (!marquee || !window.gsap) {
      return
    }

    // snapshot the original logos as templates so we can rebuild the marquee
    // (1 row on desktop, 2 rows on mobile) whenever the breakpoint changes
    var templates = Array.prototype.slice
      .call(marquee.querySelectorAll('.intro__logo'))
      .map(function (logo) {
        return logo.cloneNode(true)
      })
    if (!templates.length) {
      return
    }

    marquee.style.overflow = 'hidden'
    marquee.style.position = 'relative'

    var mobileMq = window.matchMedia('(max-width: 479px)')
    var tweens = []
    var builtForMobile = null

    function buildTrack(logos, direction) {
      var track = document.createElement('div')
      track.className = 'intro__logos__track'
      track.style.display = 'flex'
      track.style.flexWrap = 'nowrap'
      track.style.alignItems = 'center'
      track.style.minWidth = 'max-content'
      track.style.willChange = 'transform'

      // original set + a duplicate so the loop is seamless (xPercent -50)
      logos.forEach(function (logo) {
        track.appendChild(logo.cloneNode(true))
      })
      logos.forEach(function (logo) {
        track.appendChild(logo.cloneNode(true))
      })
      marquee.appendChild(track)

      animateWhenReady(track, direction)
      return track
    }

    function animateWhenReady(track, direction) {
      function start() {
        var originalWidth = track.scrollWidth / 2
        if (!originalWidth) return
        var duration = Math.max(originalWidth / 100, 25)
        // direction -1 scrolls left (0 -> -50%), +1 scrolls right (-50% -> 0)
        gsap.set(track, { xPercent: direction < 0 ? 0 : -50 })
        tweens.push(
          gsap.to(track, {
            xPercent: direction < 0 ? -50 : 0,
            ease: 'none',
            duration: duration,
            repeat: -1,
          }),
        )
      }

      var unloaded = Array.prototype.slice
        .call(track.querySelectorAll('img'))
        .filter(function (img) {
          return !img.complete
        })
      if (!unloaded.length) {
        start()
        return
      }

      var loaded = 0
      unloaded.forEach(function (img) {
        function done() {
          if (++loaded === unloaded.length) start()
        }
        img.addEventListener('load', done)
        img.addEventListener('error', done)
      })
    }

    function build() {
      tweens.forEach(function (t) {
        t.kill()
      })
      tweens = []
      marquee.innerHTML = ''

      if (mobileMq.matches) {
        // two rows moving in opposite directions; split logos across them
        var rowA = templates.filter(function (_, i) {
          return i % 2 === 0
        })
        var rowB = templates.filter(function (_, i) {
          return i % 2 === 1
        })
        buildTrack(rowA, -1)
        buildTrack(rowB.length ? rowB : rowA, 1)
      } else {
        buildTrack(templates, -1)
      }
      builtForMobile = mobileMq.matches
    }

    build()

    // rebuild only when actually crossing the mobile breakpoint
    function onChange() {
      if (mobileMq.matches !== builtForMobile) build()
    }
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onChange)
    else if (mobileMq.addListener) mobileMq.addListener(onChange)
  }

  initIntroLogosMarquee()

  function initIntroVideo() {
    var video = document.querySelector('.intro__video')
    if (!video) return

    // mobile only: don't let the markup's autoplay fire on load — just start
    // the hero video after a 2s delay. Preload eagerly (not gated on viewport)
    // so it's buffered and starts smoothly when the timer fires.
    if (!window.matchMedia('(max-width: 479px)').matches) return

    video.autoplay = false
    video.preload = 'auto'
    try {
      video.load()
    } catch (e) {}
    try {
      video.pause()
    } catch (e) {}

    setTimeout(function () {
      var playing = video.play()
      if (playing && playing.catch) playing.catch(function () {})
    }, 2000)
  }

  initIntroVideo()

  function initIntroReveal() {
    var $intro = $('.intro__text')
    if (!$intro.length) return

    var $line1 = $intro.find('.title-line-1')
    var $line2 = $intro.find('.title-line-2')
    var $body = $intro.find('.body-xxl')
    var $buttons = $intro.find('.intro__buttons').children()
    var $reveal = $line1.add($line2).add($body).add($buttons)

    // hide immediately so nothing flashes visible before the reveal animation runs
    $reveal.css({
      opacity: 0,
      visibility: 'hidden',
      transform: 'translateY(10px)',
    })

    var _introRevealPlayed = false

    function playIntroReveal() {
      if (_introRevealPlayed) return
      _introRevealPlayed = true

      if (window.gsap) {
        // three evenly-spaced, equally-paced reveals: line 1, line 2, then the
        // subtext + buttons together. Absolute positions (0, gap, gap*2) keep the
        // interval between each appearance identical; one shared duration keeps
        // them the same (slow) speed.
        // matches the original line1 → line2 tempo (0.7s fade, each next one
        // starting ~0.15s after the previous finished → 0.85s between starts),
        // now applied uniformly to all four reveals
        var revealDur = 0.7
        var revealGap = 0.85
        gsap
          .timeline({ defaults: { duration: revealDur, ease: 'power2.out' } })
          .fromTo(
            $line1.get(),
            { autoAlpha: 0, y: 10 },
            { autoAlpha: 1, y: 0 },
            0,
          )
          .fromTo(
            $line2.get(),
            { autoAlpha: 0, y: 10 },
            { autoAlpha: 1, y: 0 },
            revealGap,
          )
          .fromTo(
            $body.add($buttons).get(),
            { autoAlpha: 0, y: 10 },
            { autoAlpha: 1, y: 0 },
            revealGap * 2,
          )
          .eventCallback('onComplete', function () {
            // clear the transform but keep opacity/visibility explicitly visible —
            // clearing those would fall back to the head CSS that hides them pre-animation
            try {
              gsap.set($reveal.get(), { clearProps: 'transform' })
            } catch (e) {}
            $reveal.css({ opacity: 1, visibility: 'visible' })
          })
      } else {
        // jQuery fallback: add a reveal class that uses CSS transitions
        $reveal.addClass('intro-revealed')
        setTimeout(function () {
          $reveal
            .css({ transform: '', opacity: 1, visibility: 'visible' })
            .removeClass('intro-revealed')
        }, 900)
      }
    }

    // expose trigger and auto-start after 2s on load
    window.playIntroReveal = playIntroReveal
    setTimeout(function () {
      playIntroReveal()
    }, 2000)
  }

  initIntroReveal()

  $(window).on('scroll', toggleHeaderBlur)
  // initial check in case page is already scrolled
  toggleHeaderBlur()

  function initThreeStepsStack() {
    var containers = document.querySelectorAll('.three-simple-steps__items')
    if (!containers.length) return
    // no stacking/pinning on mobile — the cards just render in normal flow
    if (window.matchMedia && window.matchMedia('(max-width: 479px)').matches)
      return
    containers.forEach(function (container) {
      var items =
        gsap && gsap.utils
          ? gsap.utils.toArray(
              container.querySelectorAll('.three-simple-steps-item'),
            )
          : Array.prototype.slice.call(
              container.querySelectorAll('.three-simple-steps-item'),
            )
      if (!items || !items.length) return

      // pin the whole section (heading included), not just the items block,
      // so the title stays on screen while the cards stack below it
      var section =
        container.closest('.three-simple-steps') || container.parentElement

      if (
        window.gsap &&
        (window.ScrollTrigger ||
          (gsap && gsap.plugins && gsap.plugins.ScrollTrigger)) &&
        items.length > 1
      ) {
        try {
          if (gsap && gsap.registerPlugin && window.ScrollTrigger)
            gsap.registerPlugin(ScrollTrigger)
        } catch (e) {}

        container.style.position = 'relative'

        // each card keeps its own authored size/offset (that's what makes
        // them read as a fanned deck instead of identical overlapping panels).
        // Measure against the item's real offsetParent (not assumed to be
        // `container` — Webflow often nests an extra wrapper div in between),
        // otherwise the top/left below land relative to the wrong box and
        // the card can end up positioned way off, effectively invisible.
        var homeTops = items.map(function (el) {
          var beforeRect = el.getBoundingClientRect()
          el.style.position = 'absolute'
          var parent = el.offsetParent || container
          var parentRect = parent.getBoundingClientRect()
          var top = beforeRect.top - parentRect.top + parent.scrollTop
          var left = beforeRect.left - parentRect.left + parent.scrollLeft
          el.style.top = top + 'px'
          el.style.left = left + 'px'
          el.style.margin = '0'
          return top
        })

        items.forEach(function (el, i) {
          el.style.zIndex = i + 1
        })

        // each new card fully covers the previous one (no peeking deck) on all
        // desktop widths — set false to bring back the fanned/stacked deck.
        var fullCover = true

        // STACK_OFFSET 0 → cards rest in the same spot (full cover); a positive
        // value would let each earlier card peek out above the next
        var STACK_OFFSET = fullCover ? 0 : 44
        function restY(i) {
          return i * STACK_OFFSET
        }

        // cards scale down by depth: the further back in the deck a card is,
        // the smaller it gets (front = 1, one back = 0.95, two back = 0.9, …).
        // Because depth grows as new cards arrive, earlier cards get re-scaled
        // at every step, not just once.
        var SCALE_STEP = 0.05
        var RECEDE_BLUR = 2
        function depthScale(depth) {
          return 1 - depth * SCALE_STEP
        }

        var maxBottom = Math.max.apply(
          null,
          items.map(function (el, i) {
            return homeTops[i] + restY(i) + el.offsetHeight
          }),
        )
        container.style.minHeight = maxBottom + 'px'

        // each card starts off waiting below the viewport, except the first,
        // which sits in its resting spot from the start
        var offscreenY = window.innerHeight + 80
        gsap.set(items[0], { y: restY(0), scale: 1, filter: 'blur(0px)' })
        for (var i = 1; i < items.length; i++) {
          gsap.set(items[i], { y: offscreenY, scale: 1, filter: 'blur(0px)' })
        }

        var stepDistance = Math.max(window.innerHeight * 0.8, 500)

        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'top top',
            end: '+=' + stepDistance * (items.length - 1),
            pin: section,
            scrub: 0.8,
            anticipatePin: 1,
            // this pin adds a spacer that shifts everything below it, incl. the
            // [data-header-color] triggers. A higher refreshPriority makes this
            // pin recalc first on refresh, so those triggers measure their
            // start/end with the spacer already in place → header colour stays
            // correct around the pinned block
            refreshPriority: 1,
          },
        })

        items.forEach(function (item, i) {
          if (i === 0) return
          var segment = i - 1
          // the new card slides up to the front: full size, no blur, stopping
          // a notch below so the cards behind keep their tops peeking out
          tl.to(
            item,
            {
              y: restY(i),
              scale: 1,
              filter: 'blur(0px)',
              duration: 1,
              ease: 'power2.out',
            },
            segment,
          )
          // deck mode only: push every earlier card one level deeper — the
          // deeper it is, the smaller it scales (0.95, 0.9, …), so the deck fans
          // by size. In full-cover mode we leave them untouched (scale 1) so the
          // new card simply hides them completely.
          if (!fullCover) {
            for (var j = 0; j < i; j++) {
              var depth = i - j
              tl.to(
                items[j],
                {
                  scale: depthScale(depth),
                  filter: 'blur(' + RECEDE_BLUR + 'px)',
                  duration: 1,
                  ease: 'power2.out',
                },
                segment,
              )
            }
          }
        })
      } else {
        // fallback: add stacked class on scroll into view using IntersectionObserver
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  container.classList.add('stacked')
                  io.unobserve(container)
                }
              })
            },
            { threshold: 0.2 },
          )
          io.observe(container)
        } else {
          container.classList.add('stacked')
        }
      }
    })
  }

  initThreeStepsStack()

  function initAllInOneCycle() {
    var container = document.querySelector('.all-in-one__items')
    if (!container) return

    var items = Array.prototype.slice.call(
      container.querySelectorAll('.all-in-one-item'),
    )
    if (items.length < 2) return

    var visual = document.querySelector('.all-in-one__visual')
    var illustrations = visual
      ? Array.prototype.slice.call(
          visual.querySelectorAll('.all-in-one__illustration'),
        )
      : []

    var DWELL = 12 // seconds the active item stays before advancing
    var activeIndex = Math.max(
      items.findIndex(function (el) {
        return el.classList.contains('is-active')
      }),
      0,
    )
    var fallbackTimer = null
    var progressTween = null
    var illustrationTl = null

    // each visual is (or wraps) a <video>. The active tab should stay for
    // exactly that video's length instead of a fixed interval, so read the
    // video's duration and use it as the dwell (DWELL is the fallback until the
    // duration is known / if there's no video).
    function getVideo(index) {
      var el = illustrations[index]
      if (!el) return null
      return el.tagName === 'VIDEO'
        ? el
        : el.querySelector
          ? el.querySelector('video')
          : null
    }

    function getDwell(index) {
      var v = getVideo(index)
      var d = v ? v.duration : NaN
      return d && isFinite(d) && d > 0 ? d : DWELL
    }

    // make sure durations get loaded, and log them so they can be verified
    illustrations.forEach(function (el, i) {
      var v = getVideo(i)
      if (!v) {
        console.log('[all-in-one] item', i, '— no <video> found')
        return
      }
      if (v.preload === 'none') v.preload = 'metadata'
      var logDur = function () {
        console.log('[all-in-one] item', i, 'video duration:', v.duration, 's')
      }
      if (v.readyState >= 1 && isFinite(v.duration)) logDur()
      else v.addEventListener('loadedmetadata', logDur, { once: true })
    })
    var bodyTl = null

    // build an SVG ring per item so the progress arc can have a rounded
    // end cap — a plain conic-gradient can't do rounded caps on its own.
    // track is a plain full circle; the bar drawn on top is the piece
    // that actually "paints in" as progress advances
    var svgNS = 'http://www.w3.org/2000/svg'
    var RADIUS = 10
    var CIRCUMFERENCE = 2 * Math.PI * RADIUS

    var rings = items.map(function (item) {
      var host = item.querySelector('.all-in-one-item__progress')
      if (!host) return null

      var svg = document.createElementNS(svgNS, 'svg')
      svg.setAttribute('viewBox', '0 0 26 26')
      svg.setAttribute('class', 'all-in-one-item__progress-svg')

      var track = document.createElementNS(svgNS, 'circle')
      track.setAttribute('class', 'all-in-one-item__progress-track')
      track.setAttribute('cx', '13')
      track.setAttribute('cy', '13')
      track.setAttribute('r', RADIUS)

      var bar = document.createElementNS(svgNS, 'circle')
      bar.setAttribute('class', 'all-in-one-item__progress-bar')
      bar.setAttribute('cx', '13')
      bar.setAttribute('cy', '13')
      bar.setAttribute('r', RADIUS)
      bar.style.strokeDasharray = CIRCUMFERENCE
      bar.style.strokeDashoffset = CIRCUMFERENCE

      svg.appendChild(track)
      svg.appendChild(bar)
      host.appendChild(svg)

      return bar
    })

    function setProgress(index, value) {
      var bar = rings[index]
      if (bar) bar.style.strokeDashoffset = CIRCUMFERENCE * (1 - value)
    }

    // the progress ring shows only on the active item. When inactive it
    // collapses to zero width so the title sits flush-left; when it becomes
    // active it slides open and pushes the title across. The negative margin
    // swallows the flex gap between ring and title so a collapsed ring leaves
    // no phantom indent (measured per-head in case there's no gap at all).
    var progressBoxes = items.map(function (item) {
      return item.querySelector('.all-in-one-item__progress')
    })
    var headGaps = items.map(function (item) {
      var head = item.querySelector('.all-in-one-item__head')
      if (!head) return 0
      var cs = getComputedStyle(head)
      return parseFloat(cs.columnGap || cs.gap) || 0
    })
    var PROGRESS_W = progressBoxes[activeIndex]
      ? progressBoxes[activeIndex].offsetWidth
      : 24

    function toggleProgress(index, isActive, immediate) {
      var box = progressBoxes[index]
      if (!box) return
      var gap = headGaps[index]

      if (window.gsap) {
        gsap.killTweensOf(box)
        if (immediate) {
          gsap.set(
            box,
            isActive
              ? { width: PROGRESS_W, marginRight: 0, autoAlpha: 1 }
              : { width: 0, marginRight: -gap, autoAlpha: 0 },
          )
        } else if (isActive) {
          gsap.to(box, {
            width: PROGRESS_W,
            marginRight: 0,
            autoAlpha: 1,
            duration: 0.6,
            ease: 'power3.out',
          })
        } else {
          gsap.to(box, {
            width: 0,
            marginRight: -gap,
            autoAlpha: 0,
            duration: 0.4,
            ease: 'power2.in',
          })
        }
      } else {
        box.style.display = isActive ? '' : 'none'
      }
    }

    // collapse the old body and expand the new one on ONE timeline with the
    // same duration/ease so the list's height changes in a single continuous
    // motion — running them as two independent tweens (different durations)
    // made the height settle in two steps, which read as a jump
    function animateBodies(outBody, inBody, immediate) {
      if (!window.gsap) {
        if (outBody) outBody.style.display = 'none'
        if (inBody) inBody.style.display = 'block'
        return
      }

      if (bodyTl) bodyTl.kill()
      if (outBody) gsap.killTweensOf(outBody)
      if (inBody) gsap.killTweensOf(inBody)

      if (immediate) {
        if (outBody)
          gsap.set(outBody, { display: 'none', height: 0, autoAlpha: 0 })
        if (inBody)
          gsap.set(inBody, { display: 'block', height: 'auto', autoAlpha: 1 })
        return
      }

      bodyTl = gsap.timeline({
        defaults: { duration: 0.55, ease: 'power2.inOut' },
      })

      if (outBody) {
        bodyTl.to(
          outBody,
          {
            height: 0,
            autoAlpha: 0,
            onComplete: function () {
              gsap.set(outBody, { display: 'none' })
            },
          },
          0,
        )
      }

      if (inBody) {
        // measure the target height up front, then tween between two known
        // pixel values with explicit end states — both bodies then change
        // height at the same rate (smooth), and the incoming always ends
        // fully visible regardless of whatever inline opacity it carried
        // over from its previous collapse
        gsap.set(inBody, { display: 'block', height: 'auto', autoAlpha: 0 })
        var targetH = inBody.offsetHeight
        bodyTl.fromTo(
          inBody,
          { height: 0, autoAlpha: 0 },
          {
            height: targetH,
            autoAlpha: 1,
            onComplete: function () {
              gsap.set(inBody, { height: 'auto' })
            },
          },
          0,
        )
      }
    }

    function transitionIllustration(index) {
      var incoming = illustrations[index]
      if (!incoming) return

      if (!window.gsap) {
        illustrations.forEach(function (img, i) {
          img.classList.toggle('is-active', i === index)
        })
        return
      }

      if (illustrationTl) illustrationTl.kill()
      // kill any in-flight tween on every illustration, not just the pair
      // we think is involved — a fast click can interrupt a prior transition
      gsap.killTweensOf(illustrations)

      // the one currently on screen animates out; anything else still left
      // marked active (from an interrupted transition) is snapped hidden so
      // we never end up with two illustrations stacked
      var outgoing = null
      illustrations.forEach(function (img, i) {
        if (i === index) return
        if (!outgoing && img.classList.contains('is-active')) {
          outgoing = img
        } else {
          img.classList.remove('is-active')
          gsap.set(img, { clearProps: 'all' })
        }
      })

      incoming.classList.add('is-active')
      illustrationTl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      // outgoing eases left with a touch of scale/blur for depth — a hard
      // stop-then-pop reads as janky, so this overlaps slightly with the
      // entrance below instead of waiting for a full stop
      if (outgoing) {
        illustrationTl.to(
          outgoing,
          {
            xPercent: -6,
            scale: 0.96,
            autoAlpha: 0,
            filter: 'blur(8px)',
            duration: 0.9,
            ease: 'power2.inOut',
            onComplete: function () {
              outgoing.classList.remove('is-active')
              gsap.set(outgoing, { clearProps: 'all' })
            },
          },
          0,
        )
      }

      // incoming enters from the same side the outgoing exited, sliding
      // right into place as it un-blurs — started a beat before the outgoing
      // is fully gone so the motion reads as one continuous move
      illustrationTl.fromTo(
        incoming,
        { xPercent: -6, scale: 1.04, autoAlpha: 0, filter: 'blur(8px)' },
        {
          xPercent: 0,
          scale: 1,
          autoAlpha: 1,
          filter: 'blur(0px)',
          duration: 1.1,
          clearProps: 'transform,filter',
        },
        outgoing ? 0.35 : 0,
      )
    }

    function showActive(index, immediate) {
      // the item currently on screen before we retoggle classes — its body
      // is what needs to collapse in sync with the new one expanding
      var outgoingItem = items.filter(function (it) {
        return it.classList.contains('is-active')
      })[0]
      var incomingItem = items[index]

      items.forEach(function (item, i) {
        var isActive = i === index
        item.classList.toggle('is-active', isActive)
        toggleProgress(i, isActive, immediate)
        // reset the arc on every item (the active one is refilled from
        // 0 by playDwell right after) so an opening ring never flashes a
        // stale fill from its previous turn
        setProgress(i, 0)
      })

      var outBody =
        outgoingItem && outgoingItem !== incomingItem
          ? outgoingItem.querySelector('.body-m')
          : null
      var inBody = incomingItem ? incomingItem.querySelector('.body-m') : null
      animateBodies(outBody, inBody, immediate)

      transitionIllustration(index)
    }

    function playDwell(index) {
      var video = getVideo(index)
      var dwell = getDwell(index)
      console.log(
        '[all-in-one] active index',
        index,
        '| dwell (s):',
        dwell,
        '| video duration:',
        video ? video.duration : null,
      )

      // if the video's length isn't known yet, this uses the fallback dwell —
      // restart with the real value once its metadata loads (if still active)
      if (video && !(isFinite(video.duration) && video.duration > 0)) {
        video.addEventListener(
          'loadedmetadata',
          function onMeta() {
            video.removeEventListener('loadedmetadata', onMeta)
            if (index === activeIndex) {
              console.log(
                '[all-in-one] index',
                index,
                'duration now',
                video.duration,
                '→ restarting dwell',
              )
              playDwell(index)
            }
          },
          { once: true },
        )
      }

      if (window.gsap) {
        if (progressTween) progressTween.kill()
        var proxy = { value: 0 }
        progressTween = gsap.to(proxy, {
          value: 1,
          duration: dwell,
          ease: 'none',
          onUpdate: function () {
            setProgress(index, proxy.value)
          },
          onComplete: advance,
        })
      } else {
        setProgress(index, 1)
        clearTimeout(fallbackTimer)
        fallbackTimer = setTimeout(advance, dwell * 1000)
      }
    }

    function goTo(index) {
      if (index === activeIndex) return
      activeIndex = index
      if (progressTween) progressTween.kill()
      clearTimeout(fallbackTimer)
      showActive(activeIndex)
      playDwell(activeIndex)
    }

    function advance() {
      goTo((activeIndex + 1) % items.length)
    }

    items.forEach(function (item, i) {
      var target = item.querySelector('.all-in-one-item__head') || item
      target.style.cursor = 'pointer'
      target.addEventListener('click', function () {
        goTo(i)
      })
    })

    function pauseCycle() {
      if (progressTween) progressTween.pause()
      clearTimeout(fallbackTimer)
    }

    function resumeCycle() {
      if (window.gsap) {
        if (progressTween) progressTween.resume()
      } else {
        // no tween to resume in the fallback — just restart the current dwell
        playDwell(activeIndex)
      }
    }

    // collapse every inactive ring up front so nothing has to animate shut
    // on first paint (that would flash the rings the design wants hidden)
    showActive(activeIndex, true)
    playDwell(activeIndex)

    // only advance while the block is on screen: pause the countdown when it
    // scrolls out of view and resume where it left off when it comes back
    if ('IntersectionObserver' in window) {
      var inViewIo = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) resumeCycle()
          else pauseCycle()
        },
        { threshold: 0 },
      )
      inViewIo.observe(container)
    }
  }

  initAllInOneCycle()

  function initForLocalBusinessSlider() {
    var $slider = $('.for-local-business__items')
    if (!$slider.length || !$.fn.slick) return
    if ($slider.hasClass('slick-initialized')) return

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      // speed: 500,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 640, settings: { slidesToShow: 1 } },
      ],
    })

    // advance the slider on a sideways scroll (trackpad horizontal swipe or
    // shift+wheel). One gesture = one slide.
    var wheelLocked = false
    var lastDir = 0
    var lastFire = 0
    var quietTimer
    $slider.on('wheel', function (e) {
      var oe = e.originalEvent
      // only react to predominantly-horizontal intent — leave vertical page
      // scrolling untouched
      if (Math.abs(oe.deltaX) <= Math.abs(oe.deltaY)) return
      e.preventDefault()

      var dir = oe.deltaX > 0 ? 1 : -1
      var now = Date.now()

      // trackpad momentum keeps firing after a flick, so the lock only releases
      // once the wheel actually goes quiet for a moment
      clearTimeout(quietTimer)
      quietTimer = setTimeout(function () {
        wheelLocked = false
        lastDir = 0
      }, 150)

      // a clear flick in the OTHER direction releases the lock right away (so
      // reversing doesn't require waiting out the previous momentum), but not
      // within 250ms of the last switch — that guards against leftover momentum
      // bouncing the slider back
      if (
        wheelLocked &&
        dir !== lastDir &&
        Math.abs(oe.deltaX) > 6 &&
        now - lastFire > 250
      ) {
        wheelLocked = false
      }

      if (wheelLocked) return
      wheelLocked = true
      lastDir = dir
      lastFire = now
      $slider.slick(dir > 0 ? 'slickNext' : 'slickPrev')
    })
  }

  initForLocalBusinessSlider()

  function initForLocalBusinessVideo() {
    var $scope = $('.for-local-business')
    if (!$scope.length) return

    function getVideo(item) {
      return item.querySelector('.for-local-business-item__video video')
    }

    function preload(video) {
      if (!video || video.preload === 'auto') return
      // markup ships preload="metadata", so nothing is buffered until play() is
      // called — force eager buffering so hover plays instantly instead of
      // stalling on a download (the cause of "some cards don't autoplay")
      video.preload = 'auto'
      try {
        video.load()
      } catch (e) {}
    }

    // buffer each card's video (incl. slick clones — each clone has its OWN
    // <video> that needs loading) as it nears the viewport
    function observeAll() {
      var items = $scope.find('.for-local-business-item').toArray()
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return
              preload(getVideo(entry.target))
              io.unobserve(entry.target)
            })
          },
          { rootMargin: '400px 0px' },
        )
        items.forEach(function (item) {
          io.observe(item)
        })
      } else {
        items.forEach(function (item) {
          preload(getVideo(item))
        })
      }
    }
    observeAll()
    // slick may finish cloning after this runs — re-scan once more so clones
    // get observed too
    setTimeout(observeAll, 500)

    $scope.on('mouseenter', '.for-local-business-item', function () {
      var video = getVideo(this)
      if (!video) return
      preload(video)
      video._wantPlay = true

      var playing = video.play()
      if (playing && playing.catch) {
        playing.catch(function () {
          // play() can reject because the data isn't ready yet, or because a
          // previous pause interrupted it — retry once it can play, but only if
          // the pointer is still over the card
          if (!video._wantPlay || video._retrying) return
          video._retrying = true
          var onReady = function () {
            video.removeEventListener('canplay', onReady)
            video._retrying = false
            if (!video._wantPlay) return
            var again = video.play()
            if (again && again.catch) again.catch(function () {})
          }
          video.addEventListener('canplay', onReady)
        })
      }
    })

    $scope.on('mouseleave', '.for-local-business-item', function () {
      var video = getVideo(this)
      if (!video) return
      video._wantPlay = false
      video.pause()
      try {
        video.currentTime = 0
      } catch (e) {}
    })
  }

  initForLocalBusinessVideo()

  function initDelightSlider() {
    var $slider = $('.delight__items')
    if (!$slider.length || !$.fn.slick) return
    if ($slider.hasClass('slick-initialized')) return

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 500,
      arrows: true,
      fade: true,
      // wire the designer's existing arrow markup instead of slick's default
      // buttons, and keep them in their own container rather than inside the slider
      prevArrow: $('.delight-slider__arrow--prev'),
      nextArrow: $('.delight-slider__arrow--next'),
      appendArrows: $('.delight-slider__arrows'),
      dots: true,
    })
  }

  initDelightSlider()

  function initFaq() {
    var $faq = $('.faq')
    if (!$faq.length) return

    // match the markup's starting state: bodies of items flagged is-active
    // are open, the rest closed (CSS also hides them, this covers no-CSS too)
    $faq.find('.faq-item').each(function () {
      var $item = $(this)
      var $body = $item.children('.faq-item__body')
      if ($item.hasClass('is-active')) $body.show()
      else $body.hide()
    })

    // Tabs: activate the clicked tab and show its matching panel by index
    $faq.on('click', '.faq__tab', function (e) {
      e.preventDefault()
      var $tab = $(this)
      if ($tab.hasClass('is-active')) return
      var index = $tab.index()
      $tab.addClass('is-active').siblings('.faq__tab').removeClass('is-active')
      $faq
        .find('.faq__items')
        .removeClass('is-active')
        .eq(index)
        .addClass('is-active')
    })

    // Accordion: one item open per panel, jQuery slide for smooth collapse.
    // The whole item is clickable, so ignore clicks on links/buttons inside
    // the body (e.g. a link in the answer) to avoid toggling on those
    $faq.on('click', '.faq-item', function (e) {
      if ($(e.target).closest('a, button').length) return
      var $item = $(this)
      var $body = $item.children('.faq-item__body')

      if ($item.hasClass('is-active')) {
        $item.removeClass('is-active')
        $body.stop(true, true).slideUp(300)
        return
      }

      // close whichever item is currently open in the same panel
      $item
        .closest('.faq__items')
        .find('.faq-item.is-active')
        .removeClass('is-active')
        .children('.faq-item__body')
        .stop(true, true)
        .slideUp(300)

      $item.addClass('is-active')
      $body.stop(true, true).slideDown(300)
    })
  }

  initFaq()

  function splitIntoChars(el) {
    var chars = []

    function walk(node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment()
        var text = node.textContent
        for (var i = 0; i < text.length; i++) {
          var span = document.createElement('span')
          span.className = 'char'
          span.textContent = text[i]
          frag.appendChild(span)
          chars.push(span)
        }
        node.parentNode.replaceChild(frag, node)
      } else if (node.nodeType === 1 && node.tagName !== 'BR') {
        Array.prototype.slice.call(node.childNodes).forEach(walk)
      }
    }

    Array.prototype.slice.call(el.childNodes).forEach(walk)
    return chars
  }

  function initAnimationTextReveal() {
    var els = Array.prototype.slice.call(
      document.querySelectorAll('[data-animation-text]'),
    )
    if (!els.length) return

    // per-theme colours: `active` is the fully-painted state, `inactive` the
    // faded one. Keep these in sync with _animation-text.sass (the CSS sets the
    // resting colours; GSAP animates between them on scroll)
    var THEMES = {
      black: { active: 'rgba(0, 0, 0, 0.95)', inactive: 'rgba(0, 0, 0, 0.15)' },
      white: {
        active: 'rgba(255, 255, 255, 1)',
        inactive: 'rgba(255, 255, 255, 0.15)',
      },
    }

    // group sibling spans that belong to the same heading/paragraph and color theme
    var groups = []
    els.forEach(function (el) {
      var parent = el.parentElement
      var color = el.getAttribute('data-animation-text')
      var group = groups.filter(function (g) {
        return g.parent === parent && g.color === color
      })[0]
      if (!group) {
        group = { parent: parent, color: color, elements: [] }
        groups.push(group)
      }
      group.elements.push(el)
    })

    var hasGsapScroll =
      window.gsap &&
      (window.ScrollTrigger || (gsap.plugins && gsap.plugins.ScrollTrigger))
    if (hasGsapScroll) {
      try {
        if (gsap.registerPlugin && window.ScrollTrigger)
          gsap.registerPlugin(ScrollTrigger)
      } catch (e) {}
    }

    groups.forEach(function (group) {
      var theme = THEMES[group.color] || THEMES.black
      var activeChars = splitIntoChars(group.elements[0])
      var inactiveChars = []
      group.elements.slice(1).forEach(function (el) {
        inactiveChars = inactiveChars.concat(splitIntoChars(el))
      })

      if (!activeChars.length && !inactiveChars.length) return

      if (hasGsapScroll) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: group.parent,
            // start while the block is still in the lower part of the screen and
            // finish once it's ~25% from the top — a long enough range that the
            // reveal is slow/visible, ending where the title sits near the top
            start: 'center 80%',
            end: 'center 25%',
            scrub: true,
          },
        })
        if (activeChars.length) {
          tl.to(
            activeChars,
            { color: theme.inactive, stagger: 0.02, ease: 'none' },
            0,
          )
        }
        if (inactiveChars.length) {
          tl.to(
            inactiveChars,
            { color: theme.active, stagger: 0.02, ease: 'none' },
            0,
          )
        }
      } else {
        activeChars.forEach(function (c) {
          c.style.color = theme.active
        })
        inactiveChars.forEach(function (c) {
          c.style.color = theme.active
        })
      }
    })
  }

  initAnimationTextReveal()

  // Burger menu
  var $body = $('body')

  function closeMenu() {
    $('.header-burger').removeClass('is-active')
    $('.header-menu').removeClass('is-active')
    $body.removeClass('is-menu-open is-ovh')
  }

  $('.header-burger').on('click', function () {
    var willOpen = !$(this).hasClass('is-active')
    $(this).toggleClass('is-active', willOpen)
    $('.header-menu').toggleClass('is-active', willOpen)
    // is-ovh locks body scroll (overflow: hidden) while the menu is open
    $body.toggleClass('is-menu-open', willOpen).toggleClass('is-ovh', willOpen)
  })

  // clicking the menu closes it (links inside bubble up and close it too)
  $('.header-menu').on('click', function () {
    closeMenu()
  })

  // [data-scroll-to] links: smooth-scroll to the target block (offset by the
  // header height). If we're not on the home page, redirect home first and
  // finish the scroll once it loads.
  function initScrollToLinks() {
    function isHome() {
      return (
        location.pathname === '/' ||
        location.pathname === '' ||
        /\/index(\.html?)?$/.test(location.pathname)
      )
    }

    function headerOffset() {
      var header = document.querySelector('.header')
      return header ? header.offsetHeight : 0
    }

    function scrollToTarget(selector, behavior) {
      var el = selector && document.querySelector(selector)
      if (!el) return
      var y =
        el.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({ top: y, behavior: behavior || 'smooth' })
    }

    $(document).on('click', '[data-scroll-to]', function (e) {
      var target = this.getAttribute('data-scroll-to')
      if (!target) return
      e.preventDefault()
      closeMenu()

      if (isHome()) {
        scrollToTarget(target)
      } else {
        // remember where to scroll, then go home; the block below finishes it
        try {
          sessionStorage.setItem('scrollToOnLoad', target)
        } catch (err) {}
        window.location.href = '/'
      }
    })

    // arriving on the home page after a redirect — run the pending scroll once
    // the page has settled (pinned sections/images can shift positions)
    var pending
    try {
      pending = sessionStorage.getItem('scrollToOnLoad')
    } catch (err) {}
    if (pending && isHome()) {
      try {
        sessionStorage.removeItem('scrollToOnLoad')
      } catch (err) {}

      // stop the browser from restoring/resetting scroll and fighting ours
      if ('scrollRestoration' in history) {
        try {
          history.scrollRestoration = 'manual'
        } catch (err) {}
      }

      // lazy images above the target load only as you scroll, so their height
      // is 0 until then — the target measures at the wrong position (or the
      // scroll lands nowhere). Force every lazy image to load up front and wait
      // for them so the layout is stable before we measure and scroll.
      function eagerLoadImages() {
        var imgs = Array.prototype.slice.call(
          document.querySelectorAll('img[loading="lazy"]'),
        )
        imgs.forEach(function (img) {
          img.loading = 'eager'
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src')
          }
        })
        return imgs
      }

      // kick off image loading right away so the layout has settled by the time
      // the delay below elapses
      eagerLoadImages()

      function doScroll() {
        // recalc positions (pin spacers shift everything) before measuring,
        // then jump on the next frame so the refresh's own scroll adjustments
        // don't cancel ours. Instant (not smooth) so it lands exactly — a long
        // smooth scroll through the pinned section tends to stop short.
        if (window.ScrollTrigger && ScrollTrigger.refresh) {
          try {
            ScrollTrigger.refresh()
          } catch (err) {}
        }
        requestAnimationFrame(function () {
          scrollToTarget(pending, 'auto')
        })
      }

      // on a fresh redirect the page keeps growing as pins/images/fonts settle,
      // so a single early scroll lands short of the target. Jump after a delay,
      // then correct a couple more times as late shifts push the target down.
      function runPending() {
        setTimeout(doScroll, 300)
        setTimeout(doScroll, 800)
        setTimeout(doScroll, 1400)
      }

      // if the page already finished loading before this ran, the 'load' event
      // won't fire again — run now; otherwise wait for it
      if (document.readyState === 'complete') {
        runPending()
      } else {
        window.addEventListener('load', runPending)
      }
    }
  }

  initScrollToLinks()
})
